import React, { createContext, useContext, useState } from "react";

import Cookies from "js-cookie";

import {
  IBalanceMetrics,
  IBankAccount,
  IFinanceContextProps,
  IPagination,
  ITransfers,
  IUserPersonalDocuments,
} from "pages/[tenant]/cp/@types";
import { IStatement } from "pages/[tenant]/cp/statement/index.page";
import { ITransaction } from "pages/[tenant]/cp/transactions/index.page";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import { checkPermission } from "@Console/utils/checkPermissionsUtil";

const FinanceContext = createContext({} as IFinanceContextProps);

interface IFinancialProps {
  children: React.ReactNode;
  balance_operations?: {
    data: IStatement[];
    meta: IPagination;
  };
  transfers?: {
    data: ITransfers[];
    meta: IPagination;
  };
  user_personal_documents?: IUserPersonalDocuments;
  banks_accounts?: IBankAccount[];
  balance_operations_metrics?: IBalanceMetrics;
}

const FinanceProvider = ({
  children,
  balance_operations,
  transfers,
  user_personal_documents,
  banks_accounts,
  balance_operations_metrics,
}: IFinancialProps) => {
  const { rolesUser } = useAuthContext();

  const cpLastPage = Cookies.get("cpLastPage");
  const [statement, setStatement] = useState(balance_operations?.data);
  const [dataPaginationStatement, setDataPaginationStatement] = useState(
    balance_operations?.meta,
  );

  const [userBankAccount, setUserBankAccount] = useState(banks_accounts);
  const [balanceMetrics, setBalanceMetrics] = useState(
    balance_operations_metrics,
  );
  const [transfersData, setTransfersData] = useState(transfers?.data);
  const [dataPaginationTransfer, setDataPaginationTransfer] = useState(
    transfers?.meta,
  );
  const [userPersonalDocuments, setUserPersonalDocuments] = useState(
    user_personal_documents,
  );

  const [resultStatementSearch, setResultStatementSearch] = useState([]);
  const [filterSelectedStatus, setFilterSelectedStatus] = useState([]);
  const [filterSelectedOperation, setFilterSelectedOperation] = useState([]);
  const [filterSelectedStatusTransfer, setFilterSelectedStatusTransfer] =
    useState([]);
  const [filterSelectedStatusTransaction, setFilterSelectedStatusTransaction] =
    useState([]);
  const [filterSelectedSituation, setFilterSelectedSituation] = useState([]);

  const [search, setSearch] = useState("");
  const [pageSearch, setPageSearch] = useState("15");
  const [searchTransfer, setSearchTransfer] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [openModalAlert, setOpenModalAlert] = useState(false);
  const [hasActiveFilterStatement, setHasActiveFilterStatement] =
    useState(false);
  const [hasActiveFilterTransfers, setHasActiveFilterTransfers] =
    useState(false);

  const [hasActiveFilter, setHasActiveFilter] = useState(false);

  const [loading, setLoading] = useState(false);

  const [sectionFinance, useSectionFinance] = useState(cpLastPage || "initial");

  const [filterSelectedPaymentMethods, setFilterSelectedPaymentMethods] =
    useState([]);
  const [direction, setDirection] = useState("desc");
  const [ordination, setOrdination] = useState("id");

  const [filterSelectedPaymentType, setFilterSelectedPaymentType] = useState(
    [],
  );

  const [statementFilter, setStatementFilter] = useState("");

  const statementPermissions = {
    viewStatement: checkPermission(rolesUser, "visualizar-o-extrato"),
    registerNewBankAccount: checkPermission(
      rolesUser,
      "cadastrar-conta-bancaria",
    ),
    requestWithdrawal: checkPermission(rolesUser, "solicitar-um-saque"),
  };

  return (
    <FinanceContext.Provider
      value={{
        statement,
        setStatement,
        transfersData,
        setTransfersData,
        dataPaginationTransfer,
        setDataPaginationTransfer,
        dataPaginationStatement,
        setDataPaginationStatement,
        userPersonalDocuments,
        setUserPersonalDocuments,
        resultStatementSearch,
        setResultStatementSearch,
        userBankAccount,
        setUserBankAccount,
        currentPage,
        setCurrentPage,
        search,
        setSearch,
        searchTransfer,
        setSearchTransfer,
        filterSelectedStatus,
        setFilterSelectedStatus,
        filterSelectedOperation,
        setFilterSelectedOperation,
        filterSelectedStatusTransfer,
        setFilterSelectedStatusTransfer,
        filterSelectedStatusTransaction,
        setFilterSelectedStatusTransaction,
        pageSearch,
        setPageSearch,
        balanceMetrics,
        setBalanceMetrics,
        openModalAlert,
        setOpenModalAlert,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        hasActiveFilterStatement,
        setHasActiveFilterStatement,
        hasActiveFilterTransfers,
        setHasActiveFilterTransfers,
        hasActiveFilter,
        setHasActiveFilter,
        sectionFinance,
        useSectionFinance,
        filterSelectedPaymentMethods,
        setFilterSelectedPaymentMethods,
        loading,
        setLoading,
        direction,
        setDirection,
        ordination,
        setOrdination,
        filterSelectedSituation,
        setFilterSelectedSituation,
        filterSelectedPaymentType,
        setFilterSelectedPaymentType,

        statementPermissions,

        statementFilter,
        setStatementFilter,
      }}
    >
      {children}
    </FinanceContext.Provider>
  );
};

export const useFinanceContext = () => useContext(FinanceContext);

export default FinanceProvider;
